import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "poss",
    "poss",
    "PossForm",
    "/poss",
);

export default handleActions(reducers, initialState);
